var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNotLoggedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6138 11.2497C10.5467 11.2402 10.4605 11.2402 10.3838 11.2497C8.69714 11.1922 7.35547 9.81224 7.35547 8.11599C7.35547 6.38141 8.75464 4.97266 10.4988 4.97266C12.2334 4.97266 13.6421 6.38141 13.6421 8.11599C13.6326 9.81224 12.3005 11.1922 10.6138 11.2497Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9613 17.5736C15.2555 19.1357 12.9938 20.0844 10.5021 20.0844C8.01047 20.0844 5.7488 19.1357 4.04297 17.5736C4.1388 16.6728 4.7138 15.7911 5.73922 15.1011C8.36505 13.3569 12.6584 13.3569 15.2651 15.1011C16.2905 15.7911 16.8655 16.6728 16.9613 17.5736Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5013 20.0846C15.794 20.0846 20.0846 15.794 20.0846 10.5013C20.0846 5.20857 15.794 0.917969 10.5013 0.917969C5.20857 0.917969 0.917969 5.20857 0.917969 10.5013C0.917969 15.794 5.20857 20.0846 10.5013 20.0846Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotLoggedIn);
export default __webpack_public_path__ + "static/media/userNotLoggedIn.46fa08127c6fd5a2a42276d11d1bd569.svg";
export { ForwardRef as ReactComponent };